import React, { useEffect, useContext, useState } from 'react';
import FrontBody from '@/modules/storefront/components/layout/FrontBody/frontBody';

export const Storefront = () => {
 
  return (
    <>
      <FrontBody />
    </>
  )
}

export default Storefront;
